import * as heroesSection from './HeroesSection';
import * as Pages from './Pages';

import bdpsLogo3 from '../../downloads/img/bdps_logo_3.webp';
import schoolBuilding from '../../downloads/img/schoolbuilding.webp';
import director from '../../downloads/img/director-image.webp';
import principal from '../../downloads/img/principal-image.webp';
import directorMsg from '../../downloads/img/director-msg.webp';
import customizableImage from '../../downloads/img/customizable-image.webp';

let imageObj = [
    {
        id:1,
        name: 'bdps_logo_3.webp',
        link: bdpsLogo3
    },{
        id:2,
        name: 'schoolbuilding.webp',
        link: schoolBuilding
    },{
        id:3,
        name: 'director-image.webp',
        link: director
    },{
        id:4,
        name: 'principal-image.webp',
        link: principal
    },{
        id:5,
        name: 'director-msg.webp',
        link: directorMsg
    },{
        id:6,
        name: 'customizable-image.webp',
        link: customizableImage
    }
]

export { bdpsLogo3, schoolBuilding, director, principal, directorMsg, heroesSection, Pages, customizableImage, imageObj};